var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndrawBrightIdeasZ7U9(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 794.63,
    height: 804.245,
    viewBox: "0 0 794.63 804.245",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1163.575 -184.755)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.978, -0.208, 0.208, 0.978, 1335.086, 241.443)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.452,74.957c0,22.514-7.866,41.736-22.835,56.04-10.622,10.156-26.983,24.39-26.983,39.44v12.452H49.817V170.437c0-15.207-16.425-29.471-26.983-39.44C8.207,117.194,0,96.666,0,74.957V74.5a74.726,74.726,0,0,1,149.452.461Z",
    transform: "translate(30.466 78.44)",
    fill: "#0284c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.371,186.153a1.748,1.748,0,0,1-1.748-1.748V171.949c0-14.639,14.436-28.306,24.98-38.284.874-.83,1.725-1.631,2.542-2.415,14.584-13.942,22.293-32.884,22.293-54.778,0-40.919-32.054-72.974-72.973-72.974h-.206A72.85,72.85,0,0,0,3.491,76.062v.408c0,21.442,8.122,41.405,22.284,54.774.717.678,1.463,1.375,2.227,2.091,10.676,10,25.3,23.691,25.3,38.617v12.456a1.748,1.748,0,0,1-3.5,0V171.952c0-13.41-13.984-26.5-24.2-36.067q-1.15-1.078-2.236-2.1C8.521,119.759,0,98.87,0,76.472v-.42A76.352,76.352,0,0,1,76.253,0h.216a76.07,76.07,0,0,1,76.465,75.674v.8c0,22.872-8.082,42.688-23.372,57.3-.821.785-1.676,1.6-2.555,2.427-10.08,9.543-23.89,22.612-23.89,35.745v12.456a1.748,1.748,0,0,1-1.748,1.748Z",
    transform: "translate(28.729 76.924)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.125,5.827H2.913A2.913,2.913,0,1,1,2.913,0H36.125a2.913,2.913,0,1,1,0,5.827Z",
    transform: "translate(85.674 279.679)",
    fill: "#0284c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,5.073H7.855A13.663,13.663,0,0,1,.808,3.121,1.627,1.627,0,0,1,.069,1.248,1.682,1.682,0,0,1,1.7,0H21.156a1.682,1.682,0,0,1,1.633,1.248,1.627,1.627,0,0,1-.739,1.873A13.661,13.661,0,0,1,15,5.073Z",
    transform: "translate(93.761 299.952)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.588,3.666.18,3.662l-.1-.222A2.754,2.754,0,0,1,.6,1.077,2.829,2.829,0,0,1,2.829,0H31.121a2.829,2.829,0,0,1,2.227,1.078,2.737,2.737,0,0,1,.531,2.335l-.052.225Z",
    transform: "translate(88.217 291.042)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.932,27.666a2.9,2.9,0,0,1-1.916-.719L1,5.108A2.914,2.914,0,0,1,4.83.719L29.848,22.558a2.913,2.913,0,0,1-1.916,5.11Z",
    transform: "translate(0 57.06)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.916,27.669A2.913,2.913,0,0,1,1,22.559L26.018.719a2.914,2.914,0,1,1,3.833,4.39L4.832,26.947a2.9,2.9,0,0,1-1.916.72Z",
    transform: "translate(175.388 57.057)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.731,5.827H2.913A2.913,2.913,0,1,1,2.913,0H52.731a2.913,2.913,0,1,1,0,5.827Z",
    transform: "translate(77.37 269.34)",
    fill: "#0284c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.274,3.392,5.914,65.661H0L10.523,2.436a2.914,2.914,0,1,1,5.749.958Z",
    transform: "translate(87.695 195.668)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.313,65.663H10.4L.04,3.394a2.914,2.914,0,1,1,5.75-.958Z",
    transform: "translate(107.565 195.665)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,2.913A2.913,2.913,0,0,1,2.913,0H34.955a2.913,2.913,0,1,1,0,5.827H2.913A2.913,2.913,0,0,1,0,2.914Z",
    transform: "translate(86.259 194.067)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.913,55.644A2.913,2.913,0,0,1,0,52.731V2.913a2.913,2.913,0,0,1,5.827,0V52.731a2.913,2.913,0,0,1-2.913,2.913Z",
    transform: "translate(102.279)",
    fill: "#e4e4e4"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1492.174 402.414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.647,71.7a62.6,62.6,0,1,0-81.354,59.738l9.337,7.521-16.759,58.644L230.4,211.419l61.693-51.41s-13.328-16.978-20.475-36.117A62.532,62.532,0,0,0,299.648,71.7Z",
    transform: "translate(1.868 9.508)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.187,241.315l44.851,155.857,45.357-31.479L433.942,229.711c4.661-8.632,5.82-19.979,2.279-31.2-6.2-19.624-24.382-31.377-40.624-26.25s-24.384,25.193-18.19,44.816c3.54,11.215,11,19.841,19.776,24.232Z",
    transform: "translate(-375.333 0.287)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 161.785,
    height: 188.432,
    transform: "translate(171.537 303.142)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.417,611.081h376.7a2.394,2.394,0,0,0,0-4.737H32.417a2.389,2.389,0,0,0,0,4.737Z",
    transform: "translate(26.256 -24.496)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.4,435.608,358.1,547.114l2.191,53.318H88.956l52.33-164.827Z",
    transform: "translate(21.852 -14.776)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.933,151.484l38.46,87.829-3.805,150.946H161.6l-4.08-160.165,48.258-74.383Z",
    transform: "translate(22.082 1.401)",
    fill: "#0284c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.629,186.426S159.888,509.4,190.121,562.7c0,0-41.781,7.281-52.406-7.777S86.1,439.611,85.656,417.409s-13.281-266.04-13.281-266.04l76.255,35.057Z",
    transform: "translate(207.654 1.408)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.418,164.841l-3.4-8.872-86.2,34.233s4.022,322.763-30.875,355.377c0,0,58.3-2.781,60.237-4.116s44.262-168.236,44.262-168.236-20.176-77.318-21.734-110.332,37.709-98.05,37.709-98.05Z",
    transform: "translate(-138.159 1.147)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.73,198.575l-21.873-6.31L395.563,294.119l-21.554-55.788-53.252,15.214s24.207,157.079,60.8,148.631,86.174-94.711,86.174-94.711V198.575Z",
    transform: "translate(-304.196 -0.921)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.783,520.54l73.4-106.706-33.744-29.684L45.466,500.282c-8.946,1.492-17.888,7.08-24.069,16.026-10.815,15.651-9.083,35.6,3.87,44.546s32.222,3.518,43.034-12.13c6.181-8.946,8.247-19.286,6.479-28.181Z",
    transform: "translate(304.362 -11.845)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,197.548l13.028-9L119.6,389.845s8.653,12.139-2.629,31.7S47.757,501,47.757,501L2.113,475.216,48.6,388.575l-43.821-75.8Z",
    transform: "translate(343.255 -0.709)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.108,75.784c4.181-20.454,6.187-30.932,21.384-45.4,3.607.51-.952,19.214,18.93,45.268,28.9,37.874,26.022,3.148,34.568,14.814,1.855,2.532,2.255,11.671,1.643,14.814-2.41,12.422-16.668.292-1.643,42.8,2.234,3.306,4.87,2.5,8.23,2.469.261,0-1.445-.329,4.939-1.643,3.046-.629,7.31-1.372,12.422-2.233,59.387-10.006,80.352-84.936,34.452-123.919C521.59,13.879,511.341,7.16,502.442,4.045c-26.8-9.382-87.868-3.278-99.588,27.16a93.245,93.245,0,0,0-5.746,44.58Z",
    transform: "translate(-219.717 -0.001)",
    fill: "#090814",
    stroke: "#000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.353,
    cy: 42.353,
    r: 42.353,
    transform: "translate(257.347 111.353)",
    fill: "#090814",
    stroke: "#000",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1163.575 355.783) rotate(-14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.933,0A50.933,50.933,0,1,1,0,50.933,50.933,50.933,0,0,1,50.933,0Z",
    transform: "translate(0.548 0.548)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.981-.5A51.494,51.494,0,0,1,71.02,98.416,51.494,51.494,0,0,1,30.942,3.546,51.159,51.159,0,0,1,50.981-.5Zm0,101.866A50.4,50.4,0,0,0,70.593,4.555,50.4,50.4,0,0,0,31.369,97.407,50.069,50.069,0,0,0,50.981,101.366Z",
    transform: "translate(0.5 0.5)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.494 24.011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M426.978,543.306h-7.812a.685.685,0,0,1,0-1.371h7.812a.685.685,0,1,1,0,1.371Z",
    transform: "translate(-405.086 -492.955)",
    fill: "#0284c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.89,577.922h-1.681a3.213,3.213,0,0,1-1.658-.459.383.383,0,0,1-.174-.44.4.4,0,0,1,.384-.294h4.576a.4.4,0,0,1,.384.294.383.383,0,0,1-.174.44A3.214,3.214,0,0,1,435.89,577.922Z",
    transform: "translate(-417.065 -522.981)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.745,562.3h-7.858l-.024-.052a.648.648,0,0,1,.123-.556.665.665,0,0,1,.524-.253h6.655a.666.666,0,0,1,.524.253.644.644,0,0,1,.125.549l-.012.053Z",
    transform: "translate(-408.852 -509.785)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.632,525.561H404.914a.685.685,0,0,1,0-1.371h11.718a.685.685,0,0,1,0,1.371Z",
    transform: "translate(-392.788 -477.643)",
    fill: "#0284c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.884,214.185a17.668,17.668,0,0,1-5.371,13.182c-2.5,2.389-6.347,5.737-6.347,9.277v2.929H335.448v-2.929c0-3.577-3.863-6.932-6.347-9.277a18.09,18.09,0,0,1-5.371-13.182v-.108a17.577,17.577,0,1,1,35.154.108Z",
    transform: "translate(-323.322 -196.197)",
    fill: "#0284c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.591,237.738a.411.411,0,0,1-.411-.411V234.4c0-3.443,3.4-6.658,5.876-9.005.206-.2.406-.384.6-.568A17.334,17.334,0,0,0,355.9,211.94a16.982,16.982,0,0,0-17.164-17.165h-.049a17.136,17.136,0,0,0-17.116,17.068v.1a17.667,17.667,0,0,0,5.242,12.884l.524.492c2.511,2.352,5.952,5.572,5.952,9.083v2.93a.411.411,0,0,1-.822,0V234.4c0-3.154-3.289-6.234-5.691-8.483l-.526-.494a18.49,18.49,0,0,1-5.5-13.481v-.1a17.959,17.959,0,0,1,17.936-17.889h.051a17.893,17.893,0,0,1,17.986,17.8v.188a18.137,18.137,0,0,1-5.5,13.479c-.193.185-.394.376-.6.571C348.25,228.235,345,231.309,345,234.4v2.93a.411.411,0,0,1-.411.411Z",
    transform: "translate(-320.747 -193.952)",
    fill: "#3f3d56"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.996, 0.087, -0.087, 0.996, 1659.439, 184.755)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.288,0h49.29a26.288,26.288,0,0,1,26.288,26.288v49.29a26.288,26.288,0,0,1-26.288,26.288H26.288A26.288,26.288,0,0,1,0,75.578V26.288A26.288,26.288,0,0,1,26.288,0Z",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.288,2A24.266,24.266,0,0,0,2,26.288v49.29A24.266,24.266,0,0,0,26.288,99.866h49.29A24.266,24.266,0,0,0,99.866,75.578V26.288A24.266,24.266,0,0,0,75.578,2H26.288m0-2h49.29a26.288,26.288,0,0,1,26.288,26.288v49.29a26.288,26.288,0,0,1-26.288,26.288H26.288A26.288,26.288,0,0,1,0,75.578V26.288A26.288,26.288,0,0,1,26.288,0Z",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.947 23.463)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M426.978,543.306h-7.812a.685.685,0,0,1,0-1.371h7.812a.685.685,0,1,1,0,1.371Z",
    transform: "translate(-405.086 -492.955)",
    fill: "#0284c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.89,577.922h-1.681a3.213,3.213,0,0,1-1.658-.459.383.383,0,0,1-.174-.44.4.4,0,0,1,.384-.294h4.576a.4.4,0,0,1,.384.294.383.383,0,0,1-.174.44A3.214,3.214,0,0,1,435.89,577.922Z",
    transform: "translate(-417.065 -522.981)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.745,562.3h-7.858l-.024-.052a.648.648,0,0,1,.123-.556.665.665,0,0,1,.524-.253h6.655a.666.666,0,0,1,.524.253.644.644,0,0,1,.125.549l-.012.053Z",
    transform: "translate(-408.852 -509.785)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.632,525.561H404.914a.685.685,0,0,1,0-1.371h11.718a.685.685,0,0,1,0,1.371Z",
    transform: "translate(-392.788 -477.643)",
    fill: "#0284c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.884,214.185a17.668,17.668,0,0,1-5.371,13.182c-2.5,2.389-6.347,5.737-6.347,9.277v2.929H335.448v-2.929c0-3.577-3.863-6.932-6.347-9.277a18.09,18.09,0,0,1-5.371-13.182v-.108a17.577,17.577,0,1,1,35.154.108Z",
    transform: "translate(-323.322 -196.197)",
    fill: "#0284c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.591,237.738a.411.411,0,0,1-.411-.411V234.4c0-3.443,3.4-6.658,5.876-9.005.206-.2.406-.384.6-.568A17.334,17.334,0,0,0,355.9,211.94a16.982,16.982,0,0,0-17.164-17.165h-.049a17.136,17.136,0,0,0-17.116,17.068v.1a17.667,17.667,0,0,0,5.242,12.884l.524.492c2.511,2.352,5.952,5.572,5.952,9.083v2.93a.411.411,0,0,1-.822,0V234.4c0-3.154-3.289-6.234-5.691-8.483l-.526-.494a18.49,18.49,0,0,1-5.5-13.481v-.1a17.959,17.959,0,0,1,17.936-17.889h.051a17.893,17.893,0,0,1,17.986,17.8v.188a18.137,18.137,0,0,1-5.5,13.479c-.193.185-.394.376-.6.571C348.25,228.235,345,231.309,345,234.4v2.93a.411.411,0,0,1-.411.411Z",
    transform: "translate(-320.747 -193.952)",
    fill: "#3f3d56"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawBrightIdeasZ7U9);
export default __webpack_public_path__ + "static/media/undraw_bright-ideas_z7u9.58fa5809124a1aaf4029c003720f2abf.svg";
export { ForwardRef as ReactComponent };